import React, { useMemo } from "react";
import { connect } from "react-redux";

import { getDataComponentFlattenedRequestState } from "../../../../../reducers/dataComponentReducer";
import { findItemInResources } from "../../../../../utils/bluechipUtils";
import propTypes from "../../../../../constants/propTypes";

import RenderedField from "./RenderedField";

const propertiesDatacomponentId = "select-properties";

export const ProjectAddressGridContainer = ({ selectedProperty }) => {
  // Only show property address, not project_addresses
  const rows = useMemo(() => {
    if (!selectedProperty) return [];
    return [
      {
        ...selectedProperty,
        name: `${selectedProperty.name} (Property Address)`,
        isSelectedProperty: true,
      },
    ];
  }, [selectedProperty]);

  return <RenderedField rows={rows} />;
};

ProjectAddressGridContainer.propTypes = {
  selectedProperty: propTypes.property,
};

export const mapStateToProps = (state, { values }) => {
  const datacomponent = getDataComponentFlattenedRequestState(
    propertiesDatacomponentId,
    state
  );

  const selectedProperty = findItemInResources(
    datacomponent,
    state,
    values.propertyId
  );
  return {
    selectedProperty,
  };
};

export default connect(mapStateToProps)(ProjectAddressGridContainer);
